import React from "react";
import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import SignIn from "components/signin";

// Route access is driven by the live Firebase auth state in Redux (fed by
// onAuthStateChanged in verifyAuth), so signing out re-locks the UI
// immediately instead of only after a full page reload.
//
// While the session is still being restored the status is "unknown": show a
// spinner rather than the sign-in form, or a signed-in user would be bounced
// to sign-in every time they load the page.
const PrivateRoute = ({ component: Component, ...rest }) => {
  const status = useSelector((state) => state.authUser.status);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (status === "unknown") {
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "60vh",
              }}
              data-testid="auth-loading"
            >
              <CircularProgress />
            </Box>
          );
        }
        if (status === "authed") {
          return <Component {...props} />;
        }
        return <SignIn to="/" path={props.match.path} />;
      }}
    />
  );
};

export default PrivateRoute;
